<template>

  <div class="header-container-1">

    <div class="header-grid-1">>
       <div>
         <img class="head-logocircle" src="../assets/LogoCircle.png">
       </div>
    </div>

    <div class="header-grid-2">>
       <div>
         <img class="head-namekbap" src="../assets/NameKbap.png">
       </div>
    </div>

    <div class="header-grid-3">
       <div>
         <img class="head-namehouse" src="../assets/NameHouse.png">
       </div>
    </div>

  </div>

</template>

<script>

  export default {
    name: 'HomeHeader'
  }

</script>
  
<style scoped>


/* for grand screen (14.75 inches and above) */
@media (min-width:1601px) {

.header-container-1 {
    display: grid;
    grid-template-columns: 4.5fr 3fr 3fr 3fr;
    place-content: center;
    width: 100%;
    height: 100px;
    margin-top: 10px;
    background-color: rgb(255,240,133);
  }    

  .head-logocircle {
    display: grid;
    justify-self: end;
    max-width: 100px;
    height: 90px;
    margin-top: -17px;
    aspect-ratio: 1 / 1;
  }

  .head-namekbap{
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: -6px;
  }

  .head-namehouse {
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: 11px;
    margin-left: -130px;
  }
}  


/* for bigger screen (13.25 to 14.75 inches of screen) */
@media (min-width:1451px) and (max-width: 1600px) {

.header-container-1 {
    display: grid;
    grid-template-columns: 4fr 3fr 3fr 3fr;
    place-content: center;
    width: 100%;
    height: 100px;
    margin-top: 10px;
    background-color: rgb(255,240,133);
  }    

  .head-logocircle {
    display: grid;
    justify-self: end;
    max-width: 100px;
    height: 90px;
    margin-top: -17px;
    aspect-ratio: 1 / 1;
  }

  .head-namekbap{
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: -6px;
  }

  .head-namehouse {
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: 11px;
    margin-left: -70px;
  }
}  


/* for bigger desktop (12 to 13.25 inches of screen) */
@media (min-width:1301px) and (max-width: 1450px) {

.header-container-1 {
    display: grid;
    grid-template-columns: 4fr 3fr 3fr  3fr;
    place-content: center;
    width: 100%;
    height: 100px;
    margin-top: 10px;
    background-color: rgb(255,240,133);
  }    

  .head-logocircle {
    display: grid;
    justify-self: end;
    max-width: 100px;
    height: 90px;
    margin-top: -17px;
    aspect-ratio: 1 / 1;
  }

  .head-namekbap{
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: -6px;
  }

  .head-namehouse {
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: 11px;
    margin-left: -5px;
  }
}


/* for desktop (10.75 to 12 inches of screen) */
@media (min-width:1151px) and (max-width: 1300px) {

.header-container-1 {
    display: grid;
    grid-template-columns: 3fr 3fr 3fr 1fr;
    place-content: center;
    width: 100%;
    height: 100px;
    margin-top: 10px;
    background-color: rgb(255,240,133);
  }    

  .head-logocircle {
    display: grid;
    justify-self: end;
    max-width: 100px;
    height: 90px;
    margin-top: -17px;
    aspect-ratio: 1 / 1;
  }

  .head-namekbap{
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: -6px;
    margin-left: -30px;
  }

  .head-namehouse {
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: 11px;
    margin-left: -130px;
  }
}


/* for laptop (9.25-10.75 inches of screen) */
@media (min-width:1001px) and (max-width:1150px) {

.header-container-1 {
    display: grid;
    grid-template-columns: 2.5fr 3fr 3fr 1.5fr;
    place-content: center;
    width: 100%;
    height: 100px;
    margin-top: 10px;
    background-color: rgb(255,240,133);
  }    

  .head-logocircle {
    display: grid;
    justify-self: end;
    max-width: 100px;
    height: 90px;
    margin-top: -17px;
    aspect-ratio: 1 / 1;
  }

  .head-namekbap{
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: -6px;
  }

  .head-namehouse {
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: 11px;
    margin-left: -35px;
  }
}


/* for bigger ipad (8-9.25 inches of screen) */
@media (min-width:851px) and (max-width:1000px) {

.header-container-1 {
    display: grid;
    grid-template-columns: 2fr 3fr 3fr 1fr;
    place-content: center;
    width: 100%;
    height: 100px;
    margin-top: 10px;
    background-color: rgb(255,240,133);
  }    

  .head-logocircle {
    display: grid;
    justify-self: end;
    max-width: 100px;
    height: 90px;
    margin-top: -17px;
    aspect-ratio: 1 / 1;
  }

  .head-namekbap{
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: -6px;
  }

  .head-namehouse {
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: 11px;
    margin-left: 2px;
  }
}


/* for ipad (6.5-8 inches of screen) */
@media (min-width:701px) and (max-width:850px) {

.header-container-1 {
    display: grid;
    grid-template-columns: 1.5fr 3fr 3fr  0.5fr;
    place-content: center;
    width: 100%;
    height: 100px;
    margin-top: 10px;
    background-color: rgb(255,240,133);
  }    

  .head-logocircle {
    display: grid;
    justify-self: end;
    max-width: 100px;
    height: 90px;
    margin-top: -17px;
    aspect-ratio: 1 / 1;
  }

  .head-namekbap{
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: -6px;
    margin-left: 10px;
  }

  .head-namehouse {
    display: grid;
    place-self: center;
    width: 250px;
    height: 70px;
    margin-top: 11px;
    margin-left: 30px;
  }
}


/* for Phone (up to 6.5 inches of screen) */
@media (max-width:700px) {

  .head-logocircle {
    width: 7rem;
    height: auto;
    margin-top: -1rem;
  }

  .head-namekbap {
    width: 15rem;
    height: 3.5rem;
  }

  .head-namehouse {
    width: 15rem;
    height: 3.5rem;
  }
}
  
</style>